import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dialog } from 'primereact/dialog';
import api from '../../services/api';

export default function ApproveExpenses() {
  const [expenses, setExpenses] = useState([]);
  const [selectedExpenseId, setSelectedExpenseId] = useState(null);
  const [rejectionNote, setRejectionNote] = useState('');
  const [rejectVisible, setRejectVisible] = useState(false);

  const fetchExpenses = async () => {
    const res = await api.get('/expenses/pending');
    setExpenses(res.data);
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  const handleApprove = async (id) => {
    await api.put(`/expenses/${id}/approve`);
    fetchExpenses();
  };

  const handleReject = async () => {
    if (!rejectionNote.trim()) return;
    await api.put(`/expenses/${selectedExpenseId}/reject`, null, {
      params: { note: rejectionNote },
    });
    setRejectVisible(false);
    setRejectionNote('');
    setSelectedExpenseId(null);
    fetchExpenses();
  };

  const openRejectModal = (id) => {
    setSelectedExpenseId(id);
    setRejectionNote('');
    setRejectVisible(true);
  };

  const actionBodyTemplate = (rowData) => (
    <div className="flex flex-column gap-2">
      <Button
        icon="pi pi-check"
        className="p-button-success"
        onClick={() => handleApprove(rowData.id)}
      />
      <Button
        icon="pi pi-times"
        className="p-button-danger"
        onClick={() => openRejectModal(rowData.id)}
      />
    </div>
  );

  const documentTemplate = (rowData) => {
    if (!rowData.doc_path) return '-';
    return (
      <a href={`/files/${rowData.doc_path}`} target="_blank" rel="noopener noreferrer">
        Belgeyi Görüntüle
      </a>
    );
  };

  return (
    <div>
      <h3>Harcama Talepleri (Onay Bekleyen)</h3>
      <DataTable value={expenses} paginator rows={5} stripedRows>
        <Column field="user.first_name" header="Ad" />
        <Column field="user.last_name" header="Soyad" />
        <Column field="expense_type.name" header="Harcama Türü" />
        <Column field="amount" header="Tutar" />
        <Column field="reason" header="Açıklama" />
        <Column field="expense_date" header="Tarih" />
        <Column header="Belge" body={documentTemplate} />
        <Column header="İşlem" body={actionBodyTemplate} />
      </DataTable>
      <Dialog
        header="Reddetme Notu"
        visible={rejectVisible}
        onHide={() => setRejectVisible(false)}
        modal
      >
        <div className="flex flex-column gap-3">
          <InputTextarea
            value={rejectionNote}
            onChange={(e) => setRejectionNote(e.target.value)}
            placeholder="Reddetme Notu"
            autoResize
            rows={3}
            cols={40}
          />
          <div className="flex justify-content-end gap-2">
            <Button label="Vazgeç" className="p-button-text" onClick={() => setRejectVisible(false)} />
            <Button
              label="Reddet"
              className="p-button-danger"
              onClick={handleReject}
              disabled={!rejectionNote.trim()}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
